export const AddIcon = () => {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" style={{ fill: 'var(--secondary)' }} />
            <path d="M40 25V55" stroke="white" strokeWidth="3"/>
            <path d="M55 40L25 40" stroke="white" strokeWidth="3"/>
        </svg>
    );
}